import { render, staticRenderFns } from "./ParentsProfile.vue?vue&type=template&id=7e4d1f14&"
import script from "./ParentsProfile.vue?vue&type=script&lang=js&"
export * from "./ParentsProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports